export const getStoresByCoordinates = async (lat: string, lng: string) => {
	try {
		const currentStoreUrl =
			lat && lng
				? `https://api.stores.staples.ca/api/locations?lat=${lat}&lng=${lng}%20canada&rnum=12&country=CA`
				: "https://api.stores.staples.ca/api/locations?lat=43.8413273384353&lng=-79.422204502351%20canada&rnum=12&country=CA";

		const response = await fetch(currentStoreUrl);

		if (!response.ok) {
			// eslint-disable-next-line no-console
			console.error(
				"Can't fetch current stores - the response did not return 'ok'!"
			);
			return [];
		}

		const responseJson = await response.json();

		if (!Array.isArray(responseJson)) {
			// eslint-disable-next-line no-console
			console.error(
				"Can't fetch current stores - the response json was not an array!"
			);
			return [];
		}

		return responseJson;
	} catch (err: unknown) {
		// eslint-disable-next-line no-console
		console.error(
			"Can't fetch current stores - the https://api.stores.staples.ca/api/locations API failed!"
		);
		return [];
	}
};

export const getStoresByAddress = async (searchText = "") => {
	// await delay(5_000)

	const url = `https://api.stores.staples.ca/api/locations?addr=${searchText}%20canada&rnum=12&country=CA`;

	const response = await fetch(url);

	if (!response.ok) {
		// eslint-disable-next-line no-console
		return console.error("Can't fetch current stores");
	}

	const responseJson = await response.json();

	return responseJson;
};
